import './libs/foundation';
import { Howl } from 'howler';

import ContentCarousel from './components/content-carousel';
import QuickApply from './components/quick-apply';
import Nav from './components/nav';
import ScrollRevealer from './components/scrollreveal';
import StickyHeader from './components/sticky-header';
import Video from './components/video';

import Swiper, { Navigation, Autoplay } from 'swiper';
Swiper.use([Navigation, Autoplay]);

jQuery($ => {
    let contentCarousel = new ContentCarousel();
    let quickApply = new QuickApply();
    let nav = new Nav();
    let scrollRevealer = new ScrollRevealer();
    let stickyHeader = new StickyHeader();
    let video = new Video();

    if($('.js-case-studies-slider').length){
        var testimonials = new Swiper('.js-case-studies-slider', {
            modules: [ Navigation, Autoplay ],
            // Optional parameters
            direction: 'horizontal',
            loop: true,
            centeredSlides: true,
            allowTouchMove: false,
            initialSlide: 1,
            breakpoints: {
                // when window width is >= 320px
                320: {
                    spaceBetween: 20,
                    slidesPerView: 1,
                    initialSlide: 0,
                },
                730: {
                    slidesPerView: 1.75,
                    spaceBetween: 20
                },
                1000: {
                    slidesPerView: 2.25,
                    spaceBetween: 20
                },
                1550: {
                    slidesPerView: 3.5,
                    spaceBetween: 20
                }
            },

            // Navigation arrows
            navigation: {
                nextEl: '.js-case-studies-slider .swiper-button-next',
                prevEl: '.js-case-studies-slider .swiper-button-prev',
            },

        });

        $('.js-case-studies-slideout__close').click(function(e){
            const clickedIndex = $('.js-case-studies-slideout__close').index($(this));
            $('.js-case-studies-slideout').eq(clickedIndex).removeClass('is-active');
        });

        $('.js-case-studies-slider__teardrop').click(function(e){
            if($('.js-case-studies-slideout.is-active').length){
                e.preventDefault();
                return;
            }
            const clickedIndex = $(e.target).closest('.swiper-slide').data('swiper-slide-index');
            setTimeout(() => {
                $('.js-case-studies-slideout').eq(clickedIndex).addClass('is-active');
            }, 300)
        });

        $('body, html').click((e) => {
            if($('.js-case-studies-slideout.is-active').length && !$(e.target).closest('.js-case-studies-slideout').length){
                $('.js-case-studies-slideout').removeClass('is-active');
            }
        })
    }

    if($('.js-audio-testimonials').length){
        var testimonials = new Swiper('.js-audio-testimonials', {
            modules: [ Navigation ],
            // Optional parameters
            direction: 'horizontal',
            centeredSlides: true,
            grabCursor: true,
            loop: false,
            breakpoints: {
                // when window width is >= 320px
                320: {
                  spaceBetween: 20,
                  slidesPerView: 1,
                },
                // when window width is >= 640px
                640: {
                  spaceBetween: 50,
                  slidesPerView: 1.2,
                }
            },

            // Navigation arrows
            navigation: {
                nextEl: '.js-audio-testimonials .swiper-button-next',
                prevEl: '.js-audio-testimonials .swiper-button-prev',
            },

        });

        let sounds = [];

        $('.js-audio-testimonials__audio-player').each((index, player) => {
            const audioSrc = $(player).data('audio-src');
            sounds[index] = {
                player: new Howl({
                    src: [audioSrc],
                    onload: () => {
                        sounds[index].duration = sounds[index].player.duration();
                    },
                    onend: () => {
                        sounds[index].progress = 0;
                        clearInterval(sounds[index].interval);
                        $('.js-audio-testimonials__audio-player-progress').eq(index).css('width', "0%");
                        $('.js-audio-testimonials__audio-player').eq(index).removeClass('is-active');
                    }
                }),
                progress: 0,
                interval: null
            };
        });

        $('.js-audio-testimonials__audio-player').click((e) => {
            const $this = $(e.target);
            const index = $('.js-audio-testimonials__audio-player').index($this);
            const interval = 100;
            if($this.hasClass('is-active')){
                sounds[index].player.pause();
                clearInterval(sounds[index].interval);
            }
            else {
                sounds[index].player.play();
                sounds[index].interval = setInterval(() => {
                    sounds[index].progress = sounds[index].progress + interval;
                    const percentageProgress = (sounds[index].progress / (sounds[index].player.duration() * 1000)) * 100;
                    $('.js-audio-testimonials__audio-player-progress').eq(index).css('width', `${percentageProgress}%`);
                }, interval);
            }
            $this.toggleClass('is-active');
        });

        if ($(window).width() <= 768) {
            var maxHeight = 0;
            var $slides = $('.js-audio-testimonials__slide');

            // Reset heights to auto to calculate the natural height
            $slides.css('height', 'auto');

            // Determine the maximum height
            $slides.each(function() {
                var slideHeight = $(this).outerHeight();
                if (slideHeight > maxHeight) {
                    maxHeight = slideHeight;
                }
            });

            // Set all slides to the maximum height
            $slides.css('height', maxHeight + 'px');
        }

    }
});
